"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecWishlistCart = void 0;
const enums_1 = require("../enums");
const getVariant_1 = require("../helper/getVariant");
const mapCartProductToProduct_1 = require("../helper/mapCartProductToProduct");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackEecWishlistCart({ product, quantity, variant, eventName, appointment, }) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    const eventData = (0, buildGA4ProductDetail_1.buildGA4ProductDetailInteraction)({
        eventName,
        featureCategory: enums_1.GA4FeatureCategory.Ecommerce,
        product: (0, mapCartProductToProduct_1.mapCartProductToProduct)(product),
        variant: variant || (0, getVariant_1.getVariant)(appointment, product.productType),
        quantity,
    });
    const eecData = {
        event: eventName === enums_1.GA4EventName.AddToWishlist
            ? enums_1.EventName.EECAddToWishlist
            : enums_1.EventName.EECRemoveFromWishlist,
        eventAction: eventName === enums_1.GA4EventName.AddToWishlist
            ? enums_1.EventAction.AddToWishlist
            : enums_1.EventAction.RemoveFromWishlist,
        eventCategory: enums_1.EventCategory.Wishlist,
        eventLabel: product.manufacturerSku,
        nonInteraction: false,
        ...eventData,
    };
    (0, pushToDataLayer_1.pushToDataLayer)(eecData);
}
exports.trackEecWishlistCart = trackEecWishlistCart;
//# sourceMappingURL=trackEecWishListCart.js.map